/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	type ApplicationEdition,
	type ApplicationEditions,
	FREE_EDITION,
	STANDARD_EDITION,
	PREMIUM_EDITION,
	UNLICENSED,
	populateApplicationEditions,
} from '@jira/platform__application-editions/src/edition.tsx';

type MetaGetter = (name: string) => string | null;

type TenantContextEditions = {
	[applicationName: string]: string;
};

const parseTenantContextEdition = (tenantContextValue?: string): ApplicationEdition => {
	switch (tenantContextValue) {
		case 'f':
			return FREE_EDITION;
		case 's':
			return STANDARD_EDITION;
		case 'p':
			return PREMIUM_EDITION;
		default:
			return UNLICENSED;
	}
};

const parseTenantContextEditions = (
	tenantContextEditions: TenantContextEditions,
): ApplicationEditions =>
	populateApplicationEditions({
		core: parseTenantContextEdition(tenantContextEditions['jira-core']),
		software: parseTenantContextEdition(tenantContextEditions['jira-software']),
		serviceDesk: parseTenantContextEdition(tenantContextEditions['jira-servicedesk']),
		customerService: parseTenantContextEdition(tenantContextEditions['jira-customer-service']),
		productDiscovery: parseTenantContextEdition(tenantContextEditions['jira-product-discovery']),
	});

const determineApplicationEditions = (getMetaImpl: MetaGetter): ApplicationEditions => {
	try {
		const tenantContextEditions = JSON.parse(getMetaImpl('ajs-product-editions') || '{}');
		return parseTenantContextEditions(tenantContextEditions);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.warn(`Error parsing application editions from tenant context: ${error}`);
		return populateApplicationEditions();
	}
};

export default determineApplicationEditions;
